module.exports = __webpack_public_path__ + "react01.d40bc61177907f625d69c022ee07408c.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/react01.svg
// module id = 860
// module chunks = 0